<template>
    <div class="hospitalList">
        <div>
            <bread-crumb :bread-list="breadList" />
        </div>
        <div class="info-wrap">
            <div class="title-wrap">
                <i class="iconfont icon-tongyongbiaotiicon"></i>
                <span class="title-text">医生集团列表</span>
            </div>
            <div class="select-form">
                <div class="option-wrap">
                    <div class="option-item-wrap">
                        <div class="option-item">
                            <span class="label">医生集团名称</span>
                            <el-input size="small"
                                      placeholder="请输入医院集团名称"
                                      :style="{width: '280px'}"
                                      v-model="selectForm.name"
                                      @keyup.enter.native="searchHospital()">
                            </el-input>
                        </div>
                        <div class="option-item">
                            <span class="label">创建时间</span>
                            <el-date-picker size="small"
                                            clearable
                                            clear-icon="el-icon-error"
                                            v-model="selectForm.createTime"
                                            type="daterange"
                                            range-separator="-"
                                            start-placeholder="yyyy-mm-dd"
                                            end-placeholder="yyyy-mm-dd"
                                            value-format="yyyy-MM-dd"
                                            :style="{width: '280px'}"
                                            @change="handleDateChange"
                                            :picker-options="datePickerOptions"></el-date-picker>
                        </div>
                        <div class="select-btn-wrap">
                            <el-button type="primary"
                                       size="small"
                                       @click="searchHospital('search')">查询</el-button>
                            <el-button type="info"
                                       size="small"
                                       plain
                                       @click="searchHospital('reset')">重置</el-button>
                        </div>
                    </div>
                </div>
                <div class="option-wrap">
                    <el-button size="small"
                               @click="editDetail('add')">新增医生集团</el-button>
                </div>
            </div>

            <div class="table-wrap">
                <el-table :data="hospitalGroupList"
                          v-loading="loading"
                          stripe
                          style="width: 100%">
                    <el-table-column prop="name"
                                     width="90px"
                                     type="index"
                                     label="序号">
                    </el-table-column>
                    <el-table-column prop="groupName"
                                     min-width="140px"
                                     label="医生集团名称">
                        <template slot-scope="scope">
                            {{scope.row.groupName}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="doctorNumber"
                                     min-width="120px"
                                     label="医生数量">
                        <template slot-scope="scope">
                            {{scope.row.doctorNumber}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="creator"
                                     min-width="120px"
                                     label="来源">
                        <template slot-scope="scope">
                            {{scope.row.creator}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="createTime"
                                     min-width="140px"
                                     label="创建时间">
                        <template slot-scope="scope">
                            {{scope.row.createTime|getDate}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="updateTime"
                                     min-width="140px"
                                     label="修改时间">
                        <template slot-scope="scope">
                            {{scope.row.updateTime|getDate}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="name"
                                     min-width="90px"
                                     label="操作">
                        <template slot-scope="scope">
                            <span class="link-btn"
                                  @click="editDetail('edit', scope.row)">编辑</span>
                        </template>
                    </el-table-column>
                    <div slot="empty"
                         class="table-none">
                        <div>
                            <svg-icon icon-class="none1" />
                        </div>
                        <span>暂无数据</span>
                    </div>
                </el-table>
            </div>
            <div class="pagination-wrap">
                <el-pagination background
                               @current-change="pageChange"
                               :current-page.sync="page.current"
                               :page-size="page.pageSize"
                               layout="total, prev, pager, next, jumper"
                               :total="page.total"></el-pagination>
            </div>
        </div>
        <el-dialog :title="editType=='add'?'新增医生集团':'编辑医生集团'"
                   :visible.sync="isEditShow"
                   custom-class="group-dialog"
                   width="400px">
            <el-form :model="groupForm"
                     label-width="110px"
                     :rules="groupRules"
                     class="form-wrap"
                     ref="groupForm">
                <el-form-item label="医生集团名称"
                              prop="name">
                    <el-input v-model.trim="groupForm.name"
                              placeholder="请输入医生集团名称"
                              :style="{width: '250px'}"
                              maxlength="50"
                              size="small"></el-input>
                </el-form-item>
                <div class="dialog-btn-wrap">
                    <el-button size="small"
                               type="primary"
                               @click="saveForm()">保 存</el-button>
                    <el-button size="small"
                               type="info"
                               plain
                               @click="cancelForm()">取 消</el-button>
                </div>
            </el-form>
        </el-dialog>
    </div>
</template>
<style lang="scss">
.hospitalList {
    .option-wrap {
        .el-button--small {
            width: 112px;
            font-size: 14px;
            padding: 8px 15px;
        }
    }
    .select-btn-wrap {
        font-size: 0;
        .el-button--small {
            width: 80px;
            padding: 8px 15px;
            font-size: 14px;
        }
        .el-button--info.is-plain {
            background: #f5f5f5;
            border-color: #cccccc;
            color: #666;
        }
    }
}
.group-dialog {
    .el-dialog__body {
        display: flex;
        justify-content: center;
    }
    .el-form-item {
        margin-bottom: 24px;
        &.is-error {
            margin-bottom: 30px;
        }
    }
    .form-wrap {
        display: inline-block;
    }
    .dialog-btn-wrap {
        padding: 0 20px 24px 110px;
        text-align: left;
        .el-button {
            width: 96px;
            font-size: 14px;
        }
        .el-button--info.is-plain {
            background-color: #f5f5f5;
            border-color: #dbdbdb;
            color: #666;
        }
    }
}
</style>
<style lang="scss" scoped>
.info-wrap {
    background-color: #fff;
    box-shadow: 0 1px 4px 0 hsla(0, 0%, 79%, 0.5);
    position: absolute;
    left: 20px;
    right: 20px;
    bottom: 20px;
    top: 50px;
    padding: 20px;
    overflow: auto;
    .table-wrap {
        .table-none {
            height: 400px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            .icon {
                font-size: 100px;
            }
            span {
                line-height: 14px;
            }
        }
    }
}
.title-wrap {
    font-size: 0;
    padding-bottom: 20px;
    height: 16px;
    line-height: 16px;
    .icon-tongyongbiaotiicon {
        color: $color-primary;
        font-size: 16px;
        vertical-align: middle;
    }
    .title-text {
        font-size: 14px;
        color: #333333;
        margin-left: 10px;
        display: inline-block;
        height: 16px;
        line-height: 16px;
        vertical-align: middle;
    }
}
.option-wrap {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    .option-item-wrap {
        display: flex;
    }
}
.option-item {
    display: inline-block;
    font-size: 0;
    margin-right: 20px;
    .label {
        padding-right: 10px;
        font-size: 14px;
        color: #666;
        display: inline-block;
        text-align: right;
        width: 56px;
    }
    &:first-child {
        .label {
            width: 84px;
        }
    }
}
.link-btn {
    color: $a-link;
    cursor: pointer;
    font-size: 12px;
    display: inline-block;
    height: 14px;
    line-height: 14px;
    border-right: 1px solid $a-link;
    margin-right: 6px;
    padding-right: 6px;
    &:last-child {
        border-right: none;
        margin-right: 0;
        padding-right: 0;
    }
}
</style>
<script>
import { mapGetters } from 'vuex'
import shortcuts from '@/utils/pickerOptions'
import { dateToString } from '@/utils/tools'
export default {
    name: 'hospitalList',
    data () {
        return {
            breadList: [{ label: '医院管理' }, { label: '医院集团列表' }],
            datePickerOptions: {
                shortcuts: shortcuts
            },
            selectForm: {
                name: '',
                createTime: [],
                startTime: '',
                endTime: ''
            },
            page: {
                current: 1,
                total: 1,
                pageSize: 15
            },
            hospitalGroupList: [],
            isEditShow: false,
            editGroup: '',
            editType: 'add',
            groupForm: {
                name: ''
            },
            groupRules: {
                name: [{ required: true, message: '请输入医生集团名称！', trigger: 'blur' }, { required: true, message: '请输入医生集团名称！', trigger: 'change' }]
            },
            loading: true
        }
    },
    computed: {
        ...mapGetters([
            'dictionary',
            'userInfo'
        ])
    },
    methods: {
        editDetail (type, item) {
            this.editType = type
            if (this.groupForm.name) {
                this.groupForm.name = ''
                this.$nextTick(() => {
                    this.$refs['groupForm'].clearValidate()
                })
            }

            if (type === 'edit') {
                this.editGroup = item
                this.groupForm.name = item.groupName
            }
            this.isEditShow = true
        },
        async submit () {
            const param = {
                groupName: this.groupForm.name,
                creator: this.userInfo.accountName
            }
            if (this.editType === 'edit') {
                param.groupId = this.editGroup.groupId
                const { results } = await this.$services.hospital.updateHospitalGroup(param)
                if (results) {
                    this.$message.success('修改成功！')
                }
            } else {
                const { results } = await this.$services.hospital.addHospitalGroup(param)
                if (results) {
                    this.$message.success('新增成功！')
                }
            }
            this.isEditShow = false
            this.page.current = 1
            this.getData()
        },
        cancelForm () {
            this.groupForm.name = ''
            this.$nextTick(() => {
                this.$refs['groupForm'].clearValidate()
            })
            this.isEditShow = false
        },
        saveForm () {
            this.$refs['groupForm'].validate((valid) => {
                if (valid) {
                    this.submit()
                } else {
                    return false
                }
            })
        },
        handleDateChange (value) {
            if (value) {
                this.selectForm.startTime = value[0] + ' 00:00:00'
                this.selectForm.endTime = value[1] + ' 23:59:59'
            } else {
                this.selectForm.startTime = ''
                this.selectForm.endTime = ''
            }
        },
        searchHospital (type) {
            if (type === 'search') {
                this.page.current = 1
                this.getData()
            } else if (type === 'reset') {
                this.page.current = 1
                this.selectForm.startTime = ''
                this.selectForm.endTime = ''
                this.selectForm.createTime = []
                this.selectForm.name = ''
                this.getData()
            }
        },
        pageChange (value) {
            this.page.current = value
            this.getData()
        },
        async getData () {
            this.loading = true
            const param = {
                current: this.page.current,
                size: this.page.pageSize,
                createTimeStart: this.selectForm.startTime,
                createTimeEnd: this.selectForm.endTime,
                groupName: this.selectForm.name
            }
            const { results, total } = await this.$services.hospital.getHospitalGroupList(param)
            this.hospitalGroupList = results
            this.page.total = total
            this.loading = false
        },
        goDetail (item, type) {
            if (type === 'edit') {

            } else if (type === 'show') {

            }
        }
    },
    filters: {
        getDate (value) {
            if (value) {
                const date = new Date(value)
                return dateToString(date, 'yyyy-MM-dd hh:mm')
            } else {
                return value
            }
        }
    },
    created () {
        this.getData()
    }
}
</script>
